/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TuitionDiscountLine } from './TuitionDiscountLine';
import {
    TuitionDiscountLineFromJSON,
    TuitionDiscountLineFromJSONTyped,
    TuitionDiscountLineToJSON,
    TuitionDiscountLineToJSONTyped,
} from './TuitionDiscountLine';
import type { FeeLine } from './FeeLine';
import {
    FeeLineFromJSON,
    FeeLineFromJSONTyped,
    FeeLineToJSON,
    FeeLineToJSONTyped,
} from './FeeLine';
import type { TuitionLine } from './TuitionLine';
import {
    TuitionLineFromJSON,
    TuitionLineFromJSONTyped,
    TuitionLineToJSON,
    TuitionLineToJSONTyped,
} from './TuitionLine';

/**
 * 
 * @export
 * @interface CurrentTuitionPostingResponse
 */
export interface CurrentTuitionPostingResponse {
    /**
     * 
     * @type {Array<FeeLine>}
     * @memberof CurrentTuitionPostingResponse
     */
    feeLines: Array<FeeLine>;
    /**
     * 
     * @type {Array<TuitionLine>}
     * @memberof CurrentTuitionPostingResponse
     */
    tuitionLines: Array<TuitionLine>;
    /**
     * 
     * @type {Array<TuitionDiscountLine>}
     * @memberof CurrentTuitionPostingResponse
     */
    discountLines: Array<TuitionDiscountLine>;
}

/**
 * Check if a given object implements the CurrentTuitionPostingResponse interface.
 */
export function instanceOfCurrentTuitionPostingResponse(value: object): value is CurrentTuitionPostingResponse {
    if (!('feeLines' in value) || value['feeLines'] === undefined) return false;
    if (!('tuitionLines' in value) || value['tuitionLines'] === undefined) return false;
    if (!('discountLines' in value) || value['discountLines'] === undefined) return false;
    return true;
}

export function CurrentTuitionPostingResponseFromJSON(json: any): CurrentTuitionPostingResponse {
    return CurrentTuitionPostingResponseFromJSONTyped(json, false);
}

export function CurrentTuitionPostingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrentTuitionPostingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'feeLines': ((json['feeLines'] as Array<any>).map(FeeLineFromJSON)),
        'tuitionLines': ((json['tuitionLines'] as Array<any>).map(TuitionLineFromJSON)),
        'discountLines': ((json['discountLines'] as Array<any>).map(TuitionDiscountLineFromJSON)),
    };
}

export function CurrentTuitionPostingResponseToJSON(json: any): CurrentTuitionPostingResponse {
    return CurrentTuitionPostingResponseToJSONTyped(json, false);
}

export function CurrentTuitionPostingResponseToJSONTyped(value?: CurrentTuitionPostingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feeLines': ((value['feeLines'] as Array<any>).map(FeeLineToJSON)),
        'tuitionLines': ((value['tuitionLines'] as Array<any>).map(TuitionLineToJSON)),
        'discountLines': ((value['discountLines'] as Array<any>).map(TuitionDiscountLineToJSON)),
    };
}

